module.exports = __webpack_public_path__ + "static/media/preview-stories-disabled.e1439509.svg";